module.exports = __webpack_public_path__ + "fonts/material-icons-two-tone.87a93d69.woff";